import { config } from '../../config/app-config';
import { showSuccessNotification, showErrorNotification } from '../../utils/notifications';
import { apiPost } from '../../utils/api';

export function initCourseContactForm() {
    console.log('Initializing course contact form...');

    // ИСПРАВЛЕНО: Используем правильные селекторы для формы курса в модальном окне
    const input = document.querySelector("#course-registration-modal #phone");
    const label = document.querySelector('#course-registration-modal label[for="phone"]');
    const form = document.querySelector('#course-registration-modal .contact-form');
    const submitBtn = document.querySelector('#course-registration-modal .submit-btn');
    let iti;

    if (!input || !form) {
        console.log('Course contact form elements not found on this page');
        return;
    }

    // Функция создания элемента ошибки для любого поля
    function createErrorElement(inputElement) {
        if (!inputElement) return null;

        const errorElement = document.createElement('div');
        errorElement.className = 'field-error-message';

        // Делаем родительский элемент относительно позиционированным
        if (inputElement.parentElement) {
            inputElement.parentElement.classList.add('field-wrapper');
            inputElement.parentElement.appendChild(errorElement);
        }

        return errorElement;
    }

    // ИСПРАВЛЕНО: Создаем элементы ошибок для всех полей с правильными ID (заменили clinic на email)
    const phoneErrorMessage = createErrorElement(input);
    const nameErrorMessage = createErrorElement(form.querySelector('#name'));
    const emailErrorMessage = createErrorElement(form.querySelector('#email')); // ИЗМЕНЕНО: clinic -> email
    const messageErrorMessage = createErrorElement(form.querySelector('#message'));

    // Для чекбокса только рамка, без текста ошибки
    const checkboxInput = form.querySelector('.checkbox-input');

    // Универсальные функции для показа/скрытия ошибок
    function showFieldError(inputElement, errorElement, message) {
        if (!inputElement || !errorElement) return;
        inputElement.classList.add('field-error');
        errorElement.textContent = message;
        errorElement.classList.add('show');
    }

    function clearFieldError(inputElement, errorElement) {
        if (!inputElement || !errorElement) return;
        inputElement.classList.remove('field-error');
        errorElement.classList.remove('show');
    }

    function showAgreementError() {
        if (checkboxInput) {
            checkboxInput.classList.add('field-error');
        }
    }

    function clearAgreementError() {
        if (checkboxInput) {
            checkboxInput.classList.remove('field-error');
        }
    }

    // Функции для управления лейблом телефона
    function hidePhoneLabel() {
        if (label) {
            label.style.opacity = '0';
            label.style.visibility = 'hidden';
        }
    }

    function showPhoneLabel() {
        if (label && !input.value.trim()) {
            label.style.opacity = '0.6';
            label.style.visibility = 'visible';
        }
    }

    // Инициализация intlTelInput
    if (input && label && window.intlTelInput) {
        iti = window.intlTelInput(input, {
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js",
            initialCountry: "ua",
            separateDialCode: true,
            autoPlaceholder: "off",
            preferredCountries: ["ua", "pl", "us", "gb"],
            formatOnDisplay: true,
            nationalMode: false,
            validationNumberTypes: ["MOBILE", "FIXED_LINE"],
            dropdownContainer: document.body,
            fixDropdownWidth: false
        });

        console.log('intlTelInput initialized for course form');

        // Дебаг: проверяем, что дропдаун создается
        input.addEventListener('click', function() {
            console.log('Phone input clicked');
            console.log('Dropdown exists:', document.querySelector('.iti__country-list'));
        });

        // Дополнительный фикс для модалки
        const modal = document.getElementById('course-registration-modal');
        if (modal) {
            // При открытии модалки может понадобиться переинициализация
            const observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.target.classList.contains('show')) {
                        // Модалка открылась, можно обновить позицию дропдауна
                        if (iti) {
                            setTimeout(() => {
                                iti.setCountry("ua"); // Переустанавливаем страну
                            }, 100);
                        }
                    }
                });
            });

            observer.observe(modal, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
    }

    // Функция валидации номера телефона
    function validatePhone() {
        const phoneNumber = input.value.trim();

        if (!phoneNumber) {
            showFieldError(input, phoneErrorMessage, 'Поле "Телефон" обов\'язкове для заповнення');
            return false;
        }

        if (iti && iti.isValidNumber()) {
            clearFieldError(input, phoneErrorMessage);
            return true;
        } else {
            showFieldError(input, phoneErrorMessage, 'Невірний номер телефону');
            return false;
        }
    }

    // Функции валидации других полей
    function validateName() {
        const nameField = form.querySelector('#name');
        if (!nameField) return true;

        const name = nameField.value.trim();

        if (!name) {
            showFieldError(nameField, nameErrorMessage, 'Поле "Ім\'я" обов\'язкове для заповнення');
            return false;
        } else {
            clearFieldError(nameField, nameErrorMessage);
            return true;
        }
    }

    // ИЗМЕНЕНО: валидация email вместо клиники
    function validateEmail() {
        const emailField = form.querySelector('#email');
        if (!emailField) return true;

        const email = emailField.value.trim();

        if (!email) {
            showFieldError(emailField, emailErrorMessage, 'Поле "E-Mail" обов\'язкове для заповнення');
            return false;
        }

        // Проверяем формат email
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
            showFieldError(emailField, emailErrorMessage, 'Невірний формат email');
            return false;
        }

        clearFieldError(emailField, emailErrorMessage);
        return true;
    }

    function validateMessage() {
        const messageField = form.querySelector('#message');
        if (!messageField) return true;

        const message = messageField.value.trim();

        if (!message) {
            showFieldError(messageField, messageErrorMessage, 'Поле "Повідомлення" обов\'язкове для заповнення');
            return false;
        } else {
            clearFieldError(messageField, messageErrorMessage);
            return true;
        }
    }

    function validateAgreement() {
        if (!checkboxInput) return true;

        if (!checkboxInput.checked) {
            showAgreementError();
            return false;
        } else {
            clearAgreementError();
            return true;
        }
    }

    // Функция получения названия курса со страницы
    function getCourseTitle() {
        // Ищем заголовок курса на странице
        const courseTitle = document.querySelector('.header-course-detail, [data-content="course-detail-title"]');
        if (courseTitle) {
            return courseTitle.textContent.trim().replace(/\s+/g, ' ');
        }

        // Fallback: ищем в title страницы
        const pageTitle = document.title;
        if (pageTitle && pageTitle !== 'BML - News Feed') {
            return pageTitle;
        }

        // Последний fallback
        return 'Невідомий курс';
    }

    // Настройка обработчиков событий
    function setupEventListeners() {
        // Обработчики событий для поля телефона
        if (input && label) {
            input.addEventListener('focus', function() {
                hidePhoneLabel();
            });

            input.addEventListener('blur', function() {
                if (!this.value.trim()) {
                    showPhoneLabel();
                }
                validatePhone();
            });

            input.addEventListener('input', function() {
                if (this.value.trim()) {
                    hidePhoneLabel();
                } else {
                    showPhoneLabel();
                }
                clearFieldError(input, phoneErrorMessage);
            });

            input.addEventListener('change', function() {
                if (this.value.trim()) {
                    hidePhoneLabel();
                } else {
                    showPhoneLabel();
                }
                clearFieldError(input, phoneErrorMessage);
            });

            input.addEventListener('keyup', function() {
                if (this.value.trim()) {
                    hidePhoneLabel();
                } else {
                    showPhoneLabel();
                }
                clearFieldError(input, phoneErrorMessage);
            });

            input.addEventListener('countrychange', function() {
                clearFieldError(input, phoneErrorMessage);
            });

            // Начальное состояние
            if (input.value.trim()) {
                hidePhoneLabel();
            } else {
                showPhoneLabel();
            }

            // Клик по лейблу фокусирует input
            label.addEventListener('click', function() {
                input.focus();
            });
        }

        // Обработчики для других полей
        const nameField = form.querySelector('#name');
        if (nameField) {
            nameField.addEventListener('blur', validateName);
            nameField.addEventListener('input', function() {
                clearFieldError(this, nameErrorMessage);
            });
        }

        // ИЗМЕНЕНО: обработчики для email вместо clinic
        const emailField = form.querySelector('#email');
        if (emailField) {
            emailField.addEventListener('blur', validateEmail);
            emailField.addEventListener('input', function() {
                clearFieldError(this, emailErrorMessage);
            });
        }

        const messageField = form.querySelector('#message');
        if (messageField) {
            messageField.addEventListener('blur', validateMessage);
            messageField.addEventListener('input', function() {
                clearFieldError(this, messageErrorMessage);
            });
        }

        if (checkboxInput) {
            checkboxInput.addEventListener('change', function() {
                if (this.checked) {
                    clearAgreementError();
                }
            });
        }
    }

    // Функция отправки формы на сервер
    async function submitFormToServer(formData) {
        try {
            console.log('Отправка данных курса на сервер...', formData);

            // Показываем индикатор загрузки
            if (submitBtn) {
                const originalText = submitBtn.textContent;
                submitBtn.textContent = 'Відправка...';
                submitBtn.disabled = true;
            }

            const response = await apiPost(config.api.paths.courseForm, formData, {
                auth: false // Форма не требует авторизации
            });

            console.log('Ответ сервера:', response);

            // Показываем уведомление об успехе
            showSuccessNotification('Ваша заявка на курс успішно відправлена! Ми зв\'яжемося з вами найближчим часом.');

            // Очищаем форму
            form.reset();
            if (iti) {
                iti.setNumber('');
            }
            // Показываем лейбл после очистки
            showPhoneLabel();

            // Закрываем модальное окно
            const modal = document.getElementById('course-registration-modal');
            if (modal) {
                modal.classList.remove('show');
                document.body.style.overflow = '';
            }

            // Восстанавливаем кнопку
            if (submitBtn) {
                submitBtn.textContent = 'Відправити заявку';
                submitBtn.disabled = false;
            }

            return response;

        } catch (error) {
            console.error('Ошибка при отправке формы курса:', error);

            // Показываем уведомление об ошибке
            let errorMessage = 'Помилка при відправці заявки на курс. Спробуйте ще раз.';

            if (error.response && error.response.data && error.response.data.detail) {
                errorMessage = error.response.data.detail;
            }

            showErrorNotification(errorMessage);

            // Восстанавливаем кнопку
            if (submitBtn) {
                submitBtn.textContent = 'Відправити заявку';
                submitBtn.disabled = false;
            }

            throw error;
        }
    }

    // Обработка сабмита формы
    if (form) {
        form.addEventListener('submit', async function(e) {
            e.preventDefault();

            console.log('=== ОТПРАВКА ФОРМЫ КУРСА ===');

            // ИЗМЕНЕНО: валидация с email вместо clinic
            const isNameValid = validateName();
            const isPhoneValid = validatePhone();
            const isEmailValid = validateEmail(); // ИЗМЕНЕНО: clinic -> email
            const isMessageValid = validateMessage();
            const isAgreementValid = validateAgreement();

            const isFormValid = isNameValid && isPhoneValid && isEmailValid && isMessageValid && isAgreementValid;

            console.log('Валидация:', isFormValid ? 'ПРОЙДЕНА' : 'НЕ ПРОЙДЕНА');

            if (!isFormValid) {
                console.log('Есть ошибки валидации. Проверьте поля с красной рамкой.');
                showErrorNotification('Будь ласка, виправте помилки у формі');
                return;
            }

            // Получаем название курса
            const courseTitle = getCourseTitle();

            // ИЗМЕНЕНО: собираем данные формы с email вместо clinic
            const formData = {
                name: form.querySelector('#name')?.value.trim() || '',
                phone: input.value.trim(),
                email: form.querySelector('#email')?.value.trim() || '', // ИЗМЕНЕНО: clinic -> email
                message: form.querySelector('#message')?.value.trim() || '',
                agreement: checkboxInput?.checked || false,
                course_title: courseTitle
            };

            console.log('Данные формы курса:', formData);

            // Получаем дополнительную информацию о телефоне
            if (iti) {
                const phoneInfo = {
                    number: iti.getNumber(),
                    country: iti.getSelectedCountryData(),
                    isValid: iti.isValidNumber(),
                    type: iti.getNumberType()
                };
                console.log('Информация о телефоне:', phoneInfo);

                // Добавляем полный номер в международном формате
                formData.phone = iti.getNumber();
                formData.phone_country = iti.getSelectedCountryData().iso2;
            }

            try {
                await submitFormToServer(formData);
            } catch (error) {
                // Ошибка уже обработана в submitFormToServer
            }
        });
    }

    // Настраиваем обработчики событий
    setupEventListeners();

    console.log('Course contact form initialized successfully');

    // Делаем iti доступным глобально для отладки
    if (iti) {
        window.itiCourse = iti;
    }
}

export function hasCourseContactForm() {
    // ИСПРАВЛЕНО: Проверяем что есть форма курса с правильным селектором
    const courseForm = document.querySelector('#course-registration-modal .contact-form');
    return courseForm !== null;
}